// Analysis and prediction statuses are Initialised, Running, Done or Failed.

export const isTerminalAnalysis = (analysisStatus) =>
    analysisStatus === 'Done' || analysisStatus === 'Failed';

// A prediction that is neither Done nor Failed under a finished analysis will never
// finish: it is shown as not completed instead of still running.
export const predictionDisplayStatus = (predictionStatus, analysisStatus) => {
    if (predictionStatus === 'Done' || predictionStatus === 'Failed') return predictionStatus;
    return isTerminalAnalysis(analysisStatus) ? 'NotCompleted' : 'Running';
};

// Where an analysis in its current status belongs.
export const analysisPath = (analysis) => {
    const { id, anal_status } = analysis || {};
    switch (anal_status) {
        case 'Running':
            return `/laboratory/computation/${id}`;
        case 'Done':
            return `/laboratory/results/${id}`;
        case 'Initialised':
            return `/laboratory/summary/${id}`;
        default:
            return '/laboratory';
    }
};
